import { useNavigate } from 'react-router-dom';
import { STAGE_ORDER, formatStageLabel } from '../../utils/formatters';

export default function PipelineFunnel({ deals }) {
  const navigate = useNavigate();
  const stageCounts = {};
  STAGE_ORDER.forEach(s => { stageCounts[s] = 0; });
  deals.filter(d => ['active', 'information_pending'].includes(d.status)).forEach(d => {
    if (stageCounts[d.current_stage] !== undefined) stageCounts[d.current_stage]++;
  });
  const maxCount = Math.max(...Object.values(stageCounts), 1);

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      {STAGE_ORDER.map(stage => {
        const count = stageCounts[stage];
        const heightPct = Math.max(20, (count / maxCount) * 100);
        const isScreening = stage === 'screening';
        return (
          <div
            key={stage}
            style={{ flex: 1, textAlign: 'center', cursor: 'pointer' }}
            onClick={() => navigate(`/pipeline?stage=${stage}`)}
          >
            <p style={{ fontSize: 20, fontWeight: 700, color: isScreening ? 'var(--color-text-secondary)' : 'var(--color-text)', marginBottom: 4 }}>
              {count}
            </p>
            <div style={{ height: 60, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
              <div style={{
                width: '70%',
                height: `${heightPct}%`,
                background: isScreening
                  ? 'var(--color-border)'
                  : count > 0 ? 'var(--color-accent)' : 'var(--color-border-light)',
                borderRadius: 'var(--radius) var(--radius) 0 0',
                transition: 'height 0.3s',
              }} />
            </div>
            <p style={{
              fontSize: 10,
              fontWeight: 500,
              color: isScreening ? 'var(--color-text-secondary)' : 'var(--color-text-secondary)',
              marginTop: 4,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
              {formatStageLabel(stage)}
            </p>
          </div>
        );
      })}
    </div>
  );
}
